import FileView from "components/fileView";
import DynamicFormInput from "components/form/form";
import TabNav from "components/TabNav";
import { useToast } from "contexts/ToastContext";
import { useState } from "react";
import { updateAuditLawImplementation, updateLawImplementation } from "services/lawImplementationService";
import { updateLegalAdvisory } from "services/legalAdvisoryService";
import { updateLegislativeDrafting } from "services/legislativeService";
import ShowUI, { LEGISLATIVE_DRAFTING_UI_RULES } from "utils/authRules";
import { LoadingIcon } from "utils/constant";
import { LAW_IMPLEMENTATION_REQUEST_STATUS, LEGAL_ADVISORY_REQUEST_STATUS, LEGAL_RESEARCH_REGISTRAR_TABS, LEGAL_RESEARCH_REQUEST_STATUS, LEGISLATIVE_DRAFTING_REQUEST_STATUS } from "utils/constantValues";
import { formatDay } from "utils/helpers";
import LegislativeDraftDetail from "./fragments/leftPanel";
import LegislativeDraftRightPanel from "./fragments/rightPanel";
import { useTranslation } from "react-i18next";

export default function RegistrarLegislativeDraft({ request }: { request: any }) {
    const { t } = useTranslation();
    const [activeTab, setActiveTab] = useState("Research Finding");
    const [letterRefNum, setLetterRefNum] = useState("");
    const [submitting, setSubmitting] = useState(false);
    const { showToast } = useToast();
    
    const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        setLetterRefNum(e.target.value)
    }
    
    const [formState, setFormState] = useState({ ...request });

    const handleSave = async () => {
        setSubmitting(true);
        const data = new FormData();
        data.append(
            "current_approval_status",
            LAW_IMPLEMENTATION_REQUEST_STATUS.letter_refnum_submitted.value
        );
        data.append(
            "forward_status",
            LEGAL_ADVISORY_REQUEST_STATUS.forwarded_to_director.value
        );
        data.append("registry_number", letterRefNum);

        try {
            const response = await updateAuditLawImplementation(formState.id, data);

            setFormState({ ...response });
            showToast(t("LegalResearchRespondedBackSuccess") || "Legal research responded back successfully!", "success");
        } catch (error) {
            console.error("Error submitting request:", error);
            showToast(t("FailedToUpdateLegalResearchRequest") || "Failed to update legal research request.", "error");
        } finally {
            setSubmitting(false);
            setLetterRefNum("");
        }
    };

    return (
        <div className="flex-1">
            <ShowUI
                ui_key={LEGISLATIVE_DRAFTING_UI_RULES.edit_reference_number.value}
                currentStatus={formState.current_approval_status}
                forwardStatus={formState.forward_status}
            >
                {activeTab === "Research Finding" &&
                    <div className="flex w-full gap-8">
                        {formState?.draft_law_file &&
                            <div className="bg-white flex-1 p-4 rounded-lg border border-gray-200 shadow-md">
                                <div className="pb-2 border-b border-gray-200 mb-4">
                                    <p>{t("DraftLawDetail") || "Draft Law Detail"}</p>
                                </div>
                                {formState?.letter_reference_number &&
                                    <p className="text-[#747171] font-normal text-xs mb-3">{t("LetterReferenceNumber") || "Letter Reference Number"}: {formState?.letter_reference_number}</p>
                                }
                                <p className="text-[#747171] font-normal text-xs mb-3">{formatDay(formState?.created_at).rest}</p>
                                <p className="font-regular text-base text-[#606060]">{formState?.draft_summary}</p>
                                <div className="flex border border-gray-200 p-2 rounded-lg my-4">
                                    <FileView title={t("DraftInstruction") || "Draft Instruction"} file={formState?.draft_law_file} />
                                </div>
                            </div>}
                        <div className="flex flex-col flex-1 max-w-4xl bg-white rounded-lg shadow-md p-6 mb-4 h-fit">
                            <DynamicFormInput
                                inputs={[
                                    {
                                        value: letterRefNum,
                                        type: "text",
                                        label: t("LetterReferenceNumber") || "Letter Reference Number",
                                        name: "letter_reference_number",
                                        onChange: handleChange,
                                        placeholder: t("LetterReferenceNumberPlaceholder") || "Eg. 12345",
                                    },
                                ]} />
                            <button 
                                onClick={handleSave} 
                                disabled={submitting}
                                className="bg-[#212121] hover:bg-[#141414] mt-4 text-white font-bold py-3 px-8 rounded-md w-full disabled:opacity-70"
                            >
                                {submitting ? (
                                    <div className="flex items-center justify-center">
                                        {LoadingIcon} {t("Submitting") || "Submitting..."}
                                    </div>
                                ) : (
                                    t("Save") || "Save"
                                )}
                            </button>
                        </div>
                    </div>
                }
            </ShowUI>
        </div>
    );
}